import { Component, Output, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'se-text-editor-menu-item',
  templateUrl: './se-text-editor-menu-item.component.html',
  styleUrls: ['./se-text-editor-menu-item.component.scss']
})
export class SeTextEditorMenuItemComponent {
  @Input() disabled: boolean;
  @Input() label: string;
  @Input() matIconName: string;
  @Output() click = new EventEmitter();
}
